import apolloClient from 'apollo-client'
import filter from 'lodash/filter'
import {
  CREATE_CARRIER_FULFILLMENT,
  CREATE_FULFILLMENT,
} from 'app/features/orders/graphql/fulfillment'
import {
  Fulfillment,
  FulfillmentItem,
  fulfillmentStatusTypes,
  fulfillmentTypes,
} from 'app/features/orders/models'

class FulfillmentService {
  public createFulfillment = async (fulfillment: Fulfillment) => {
    return await apolloClient.mutate({
      mutation: CREATE_FULFILLMENT,
      variables: {
        fulfillment,
      },
    })
  }

  public createCarrierFulfillment = async ({fulfillment, fulfillmentItems}: any) => {
    const {data} = await apolloClient.mutate({
      mutation: CREATE_CARRIER_FULFILLMENT,
      variables: {
        fulfillment,
        fulfillmentItems,
      },
    })
    if (data.error) {
      console.error(data.error)
      throw data.error
    }

    return data.carrierFulfillmentCreate
  }

  public createManualFulfillment = async (order: any, tracking: any) => {
    const fulfillment = mapOrderToFulfillment(order, tracking, fulfillmentStatusTypes.pending)
    return this.createFulfillment(fulfillment)
  }
}

const fulfillmentService = new FulfillmentService()
export default fulfillmentService

const mapOrderToFulfillment = (order: any, tracking: any, fulfillmentStatus: string) => {
  const items = filter(order.orderItems, (item: any) => item.fulfillmentQuantity > 0)
  const fulfillmentItems: FulfillmentItem[] = items.map((item: any) => ({
    orderItemId: item.id,
    quantity: item.fulfillmentQuantity,
    variantId: item.variantId,
    price: item.price,
  }))

  const fulfillment: Fulfillment = {
    orderId: order.id,
    status: fulfillmentStatus,
    fulfillmentType: fulfillmentTypes.inHouse,
    fulfillmentItems: {create: fulfillmentItems},
    tracking: tracking,
    locationId: order.fulfillmentLocationId,
  }
  return fulfillment
}
